import { HTTPError } from "./HTTPError";

export class ForbiddenError extends HTTPError {}
